// extracted by mini-css-extract-plugin
export default {"SiteFooter":"SiteFooter_SiteFooter__xxIyP","linksBlock":"SiteFooter_linksBlock__R6xmV","languageSelect":"SiteFooter_languageSelect__xYgtz"};